import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, Row } from "react-bootstrap";
import { Tooltip } from 'react-tooltip'
import { SearchIcon } from '@primer/octicons-react'
import LocPickerDialog from './LocPickerDialog';
import { BiHelpCircle } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const DatapointAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [datapointAttrs, setDatapointAttrs] = useState({
    code: '',
    description: '',
    typeId: '',
    datasourceId: '',
    assetCode: '',
    location: '',
    locationId: '',
    externalSystemId: '',
    externalSystemId2: '',
    status: ''
  });

  const [datapointTypeList, setDatapointTypeList] = useState([]);
  const [datasourceList,  setDatasourceList]  = useState([]);

  const [showLocPickerDialog, setShowLocPickerDialog] = useState(false);

  /* ##### Future enhancement #####
  const statusOptions = [
    { key: "ACTIVE",    value: "ACTIVE" },
    { key: "DISABLED",  value: "DISABLED" }
  ];
  */

  // Initialize state
  useEffect(() => {
    fetchDatapointTypes();
    fetchDatasources();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const fetchDatapointTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoint-types");

        resolve(res.data);

        if (res.status === 200) {
          setDatapointTypeList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchDatasources = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datasources");

        resolve(res.data);

        if (res.status === 200) {
          setDatasourceList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  // UI Functions

  // Location select dialog stuff

  const handleLocPicker = (e) => {
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {
/* ##### If I do this, the locationId is NOT set.  Why??? #####
    setDatapointAttrs({ ...datapointAttrs, locationId: location.id });
    setDatapointAttrs({ ...datapointAttrs, location:   location.code });
*/
    // Deep copy
    let newDatapointAttr = JSON.parse (JSON.stringify(datapointAttrs));
    newDatapointAttr.locationId = location.id;
    newDatapointAttr.location   = location.code;

    setDatapointAttrs(newDatapointAttr);

    setShowLocPickerDialog(false);
  }


  // General stuff
  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setDatapointAttrs({ ...datapointAttrs, [e.target.name]: e.target.value })
  }

  const onDatapointTypeClick = (dpTypeId) => {
    setDatapointAttrs({ ...datapointAttrs, typeId: dpTypeId })
  }

/*
  const onDatasourceSelect = (key, event) => {
    setDatapointAttrs({ ...datapointAttrs, datasourceId: key })
  };
*/

  const onDatasourceClick = (datasourceId) => {
    setDatapointAttrs({ ...datapointAttrs, datasourceId: datasourceId })
  }

  /* ##### Future enhancement #####
  const onStatusClick = (key) => {
    setDatapointAttrs({ ...datapointAttrs, status: key })
  }
  */

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!datapointAttrs.code || datapointAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_datapoint_code"));
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoints?code=" + datapointAttrs.code);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_datapoint_code_taken"));
        } else {
          validateOtherFields();
        }

        return;

      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {

    // Validate form inputs
    if (datapointAttrs.code.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 100);
    } else if (!datapointAttrs.description || (datapointAttrs.description.trim().length === 0)) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (datapointAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (datapointAttrs.typeId === '') {
      setErrMsg(t("I18N_ERR_Need_dpType"));
    } else if (datapointAttrs.datasourceId === '') {
      setErrMsg(t("I18N_ERR_Need_datasource"));
    } else if (datapointAttrs.externalSystemId.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id") + 100);
    } else if (datapointAttrs.externalSystemId2.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id2") + 100);
    } else if (datapointAttrs.assetCode.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_asset_code") + 50);
    } else {
      setErrMsg('');
      createNewDatapoint();
    }
  }

  const createNewDatapoint = () => {

console.log("datapointAttrs: ", datapointAttrs);
    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(datapointAttrs));

    // Note: reqBody.location is actually not used by the API
    if (reqBody.location === '') {
      reqBody.locationId = '';
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("datapoints", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', height:'600px', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Datapoint")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Datapoint_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Datapoint_code")}: *</Col>
              <Col>{t("I18N_Description")}: *</Col>
              <Col>
                <span>{t("I18N_Ext_sys_id")}:</span>
                <span style={{marginLeft:'5px'}} data-tooltip-id="ext-sys-id-tip" data-tooltip-html={t("I18N_TIP_Ext_sys_id")} >
                   <BiHelpCircle size={14} />
                </span>
                <Tooltip id="ext-sys-id-tip" />
              </Col>
              <Col>{t("I18N_Ext_sys_id2")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={datapointAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description" value={datapointAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="externalSystemId" value={datapointAttrs.externalSystemId}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="externalSystemId2" value={datapointAttrs.externalSystemId2}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Datapoint_type")}: *</Col>
              <Col>{t("I18N_Datasource")}: *</Col>
              <Col>{t("I18N_Asset_code")}:</Col>
              <Col>{t("I18N_Location_code")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <Dropdown>
                  <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                    {!datapointAttrs.typeId ? t("common:I18N_DROPDOWN_PROMPT") :
                          (datapointTypeList.find( ({ id }) => id === parseInt(datapointAttrs.typeId) )).code}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                    {datapointTypeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onDatapointTypeClick(item.id)}>
                          {item.code}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col>
                <Dropdown>
                  <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                    {!datapointAttrs.datasourceId ? t("common:I18N_DROPDOWN_PROMPT") :
                          (datasourceList.find( ({ id }) => id === parseInt(datapointAttrs.datasourceId) )).code}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                    {datasourceList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onDatasourceClick(item.id)}>
                          {item.code}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="assetCode" value={datapointAttrs.assetCode}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input readOnly className={classes.admin_pages__field_editable} style={{minWidth: '85%'}} name="location" value={datapointAttrs.location}
                  onChange={(e) => onAttrsInputChange(e)} />
                <span onClick={handleLocPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <SearchIcon size={14} />
                </span>
              </Col>
            </Row>

            {/* ##### Future enhancement #####
            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Status")}: *</Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <Dropdown>
                  <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.custom_dropdown_menu} id="dropdown-basic-button">
                    {!datapointAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : datapointAttrs.status}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                    {statusOptions.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.custom_dropdown_menu} onClick={() => onStatusClick(item.key)}>
                          {item.value}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
            */}


            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />

      </Card>
    </>
  );
}

export default DatapointAdminNewView;
